<template>
  <div class="inforPerfection appointment">
    <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>
    <div class="setNavBg">
      <v-header class="hidden-xs hidden-sm" :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-header>
    </div>
    <v-publicBanner :bannerInfo="bannerInfo"></v-publicBanner>
    <div class="inforPerfectionCon">

        <div class="inforPerfectionTop">
          <p class="hotline">如需更好的了解一链采购供应链数智化系统，寻求更多采购供应链解决方案，入驻成为平台采购商，请您填写以下信息，或拨打免费服务热线：<span>400-108-6116</span></p>
          <el-form v-show="successShow" :model="ruleForm" :rules="rules" ref="recruitForm" label-width="92px" class="demo-ruleForm">
            <!--<el-form-item label="角色" prop="roleName">-->
              <!--<el-select v-model="ruleForm.roleName" placeholder="请输入角色">-->
                <!--<el-option-->
                  <!--v-for="item in options"-->
                  <!--:key="item.value"-->
                  <!--:label="item.label"-->
                  <!--:value="item.value">-->
                <!--</el-option>-->
              <!--</el-select>-->
            <!--</el-form-item>-->
<!--            <el-form-item label="角色" prop="roleName">-->
<!--              <el-radio-group v-model="ruleForm.roleName">-->
<!--                <el-radio v-for="item in options" :label="item.value" :key="item.value">{{item.label}}</el-radio>-->
<!--              </el-radio-group>-->
<!--            </el-form-item>-->
            <el-form-item label="姓名" prop="userName">
              <el-input v-model="ruleForm.userName" placeholder="请输入姓名"  :maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="职位" prop="positionName">
              <el-input v-model="ruleForm.positionName" placeholder="请输入职位"  :maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="contractPhone">
              <el-input v-model="ruleForm.contractPhone" placeholder="请输入联系电话"  :maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="公司名称" prop="companyName">
              <el-input v-model="ruleForm.companyName" placeholder="请输入公司名称"  :maxlength="50"></el-input>
            </el-form-item>
<!--            <el-form-item label="试用平台" prop="trialPlatform">-->
<!--              <el-checkbox-group v-model="ruleForm.trialPlatform" @change="handleChange">-->
<!--                <el-checkbox label="采招平台" ></el-checkbox>-->
<!--                <el-checkbox label="协同平台" ></el-checkbox>-->
<!--                <el-checkbox label="供应商管理" ></el-checkbox>-->
<!--                <el-checkbox label="征信产品" ></el-checkbox>-->
<!--              </el-checkbox-group>-->
<!--            </el-form-item>-->
            <div class="clearfix">
              <div class="trialPlatform-label pull-left">
                <i style="color: #f56c6c;">*</i>
                我的需求
                <el-tooltip class="item" effect="dark" content="贵公司希望通过一链网，解决当前采购遇到的哪些问题？" placement="top">
                  <el-button type="text" style="vertical-align: middle;">
                    <i class="el-icon-question"></i>
                  </el-button>
                </el-tooltip>
              </div>
              <div class="pull-left trialPlatform-item" style="width: 300px;font-size: 12px">
                <el-form-item label-width="0" prop="trialPlatform">
                  <el-input v-model="ruleForm.trialPlatform"
                            style="font-size: 12px;"
                            type="textarea"
                            :maxlength="100"
                            :show-word-limit="true"
                            placeholder="如 电子招标、供应商管理、合同管理"
                            :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
                </el-form-item>
              </div>
            </div>
            <el-form-item label="">
              <el-button type="primary" @click="submitForm()">提交</el-button>
            </el-form-item>
          </el-form>
          <div v-show="!successShow" class="successPrompt">
            <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/registerSuccess.png" alt="">
            <h5>注册成功</h5>
            <a @click.prevent="goToHref('/')">返回首页</a>
          </div>

        </div>
    </div>
    <v-footer :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos'></v-footer>
    <v-backToTop></v-backToTop>
  </div>

</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import publicBanner from '@/components/publicBanner'
  import footer from '@/components/v-footer'
  import backToTop from '@/components/backToTop'
  import { mapState } from 'vuex'

  export default {
    props: [],
    data () {
      var checkMobile = (rule, value, callback) => {
        var reg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        var isMob=  /^0\d{2,3}-?\d{7,8}$/;// 座机格式
        if (!reg.test(value)&&!isMob.test(value)) {
          return callback(new Error('请输入有效的联系电话'));
        }else{
          return callback();
        }
      };
      return {
        options: [{
          value: '0',
          label: '采购商'
        }, {
          value: '1',
          label: '供应商'
        }],
        showFlag:true,
        disabledAddressFlag:true,
        showButtonFlag:true,
        initOrgName:'',
        creditCompanyInfo:{},
        selectCompanyName:'',
        searchVagueCompany:'',
        companyListShow:false,
        companyData:[],
        selectCompanyId:'',
        companySearch:'',
        disabledFlag:true,
        deleteOrgTxt:'',
        deleteLicTxt:'',
        deleteThreeLicTxt:'',
        deleteTaxTxt:'',
        businessEndTimeShowFlag:true,
        checkBusinessBeginTimeFlag:true,
        foundDateCount:0,
        businessEndTimeCount:0,
        foundDate:null,
        businessEndTime:null,
        regeistFileName:'',
        companyDiabledFlag:false,
        regeistFileDisableFlag:false,
        threeShowflag:true,
        checkFlag:true,
        filterIndustryFlag:false,
        filterServiceFlag:false,
        filterIndustryNumber:0,
        filterServiceNumber:0,
        loading:false,
        filterIndustryKey:'',
        filterServiceKey:'',
        addressFlag:false,
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{},
        navigationColumnInfos: [],
        industryTree:[],
        industryTreeStorage:[],
        serviceTree:[],
        serviceTreeStorage:[],
        industryShowFlag:false,
        serviceShowFlag:false,
        defaultCheckIndustryKey:[],
        multipleIndustrySelection:[],
        multipleServiceSelection:[],
        industryShowContent:'',
        serviceShowContent:'',
        threeFlag:true,
        showThreeLienceFlag:false,
        showLienceFlag:false,
        showOrganizationFlag:false,
        showTaxFlag:false,
        showBussinessFlag:false,
        countries:[],
        provinces:[],
        cities:[],
        bannerInfo: {title: '预约沟通',content: "Appointment communication"},
        webConfigInfo: {},
        footerColumnInfos:[],
        defaultIndustryProps: {
          label: 'industryName',
          children: 'children',
        },
        defaultServiceProps: {
          label: 'serviceName',
          children: 'children',
        },
        serviceData:{},
        serviceDatas:[],
        serviceExtDatas:[],
        industryData:{},
        industryDatas:[],
        industryExtDatas:[],
        ruleForm: {
          // roleName: '',
          userName: '',
          positionName: '',
          contractPhone: '',
          companyName: '',
          trialPlatform: ''
        },
        orgId:'',
        companyInfo:{},
        ucenterInfo:{},
        rules: {
          // roleName: [
          //   { required: true, message: '请选择角色', trigger: 'change' }
          // ],
          userName: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ],
          companyName: [
            { required: true, message: '请输入公司名称', trigger: 'blur' }
          ],
          positionName: [
            { required: true, message: '请输入职位', trigger: 'blur' }
          ],
          contractPhone: [
            { required: true, message: '电话不能为空', trigger: 'blur' },
            { validator: checkMobile, trigger: 'blur' }

          ],
          trialPlatform: [
            { required: true, message: '请输入您的需求', trigger: 'blur' }
          ]
        },
        successShow:true
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-publicBanner': publicBanner,
      'v-footer': footer,
      'v-backToTop': backToTop
    },
    computed:
      mapState([
        'KP'
      ]),
    created () {

      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCompleteInfo', {
        orgId:this.orgId
      }).then((res) => {
        this.data = res.data;
      this.webConfigInfo = this.data.webConfigInfoDto;
      this.footerColumnInfos = this.data.footerColumnInfos;
      this.navigationColumnInfos = this.data.navigationColumnInfos;
      this.hitSearchUrl = this.data.hitSearchUrl;
      this.yellowPageColumn = this.data.yellowPageColumn;
      this.productAndSolutionColumn = this.data.productAndSolutionColumn;
      this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      this.countries = this.data.countries;
      this.provinces = this.data.provinces;
      this.cities = this.data.cities;
      this.ucenterInfo = this.data.uCenterOrgInformationDto;


      this.baseInforRuleForm.businessScope = this.ucenterInfo.businessScope ;
    }).catch((err) => {
        console.log(err)
    })
    },
    mounted () {
      this.hideLise();
    },
    methods: {
      submitForm() {
        this.$refs['recruitForm'].validate((valid) => {
          if (valid) {
            this.$axios.post('/onelink.mdata.main.api/task/addTaskInfo', {
              taskSource: 0,
              // roleName: this.ruleForm.roleName,
              userName: this.ruleForm.userName,
              positionName:this.ruleForm.positionName,
              contractPhone: this.ruleForm.contractPhone,
              companyName: this.ruleForm.companyName,
              trialPlatform: this.ruleForm.trialPlatform,
              operateStaus: 0
            }).then((res) => {
              this.data = res.data;
            let operateNumber = this.data.data;
            if(res.data.code == '0'){
              if(this.getToken('isLogin') == ''){

                if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
                  this.$message({
                    dangerouslyUseHTMLString: true,
                    message: '<strong>试用申请已提交,请到PC端, <span style="color:red">三分钟快速注册</span></strong>'
                  });
                  return;
                } else {
                  this.$message({
                    dangerouslyUseHTMLString: true,
                    message: '<strong>试用申请已提交, <a href="/register" style="color:red">三分钟快速注册</a></strong>'
                  });
                  return;
                }

              }else{
                this.$message({
                  message: "试用申请已提交",
                  type: 'success'
                });
                this.successShow = false;
              }
              this.centerDialogVisible = false;
            }else{
              this.$message({
                message: "试用提交失败!",
                type: 'error'
              });
            }
          }).catch((err) => {
              console.log(err)
          })
          } else {
            return false;
      }
      });
      },
      // handleChange(value){
      //   this.ruleForm.trialPlatform = value;
      // },
      hideLise(){
        $('body').click(()=>{
          this.companyListShow=false
      })
      },
      updateButton(val){
        if(this.initOrgName !=val){
          this.showButtonFlag = false;
        }else{
          this.showButtonFlag = true;
        }
      },
      loadCompanys(){
        this.selectCompanyName='';
        this.searchVagueCompany = this.baseInforRuleForm.orgName;
        this.$axios.post('/onelink.mdata.main.api/credit/creditFuzzyQuery', {
          companyName: this.baseInforRuleForm.orgName,
          pageNo:1,
          pageSize:10
        }).then((res) => {
          if(res.data.length>0){
          this.companyListShow=true;
        }else{
          this.$alert('<i class="el-icon-error" style="font-size: 32px;color: #F56C6C;position: absolute"></i><p style="padding-left: 48px">抱歉，没有找到相关结果！您可以:</p><p style="padding-left: 48px">1.输入准确的关键词，重新搜索</p><p style="padding-left: 48px">2.点击屏幕右侧"咨询客服"与我们在线沟通。</p>', '', {
            dangerouslyUseHTMLString: true
          });
        }
        this.data = res.data;
        this.companyData = [];
        this.companyData = this.data;
        // this.baseInforRuleForm.orgName = this.searchVagueCompany;
      }).catch((err) => {
          console.log(err)
      })

      },
      selectCompany(companyId){
        this.baseInforRuleForm.orgName = companyId;
        this.companySearch = this.selectCompanyName;
        // this.baseInforRuleForm.orgName =companyId.split(",")[1];
        this.$axios.post('/onelink.mdata.main.api/mainInfo/findCreditcompanyInfo', {
          companyName: this.baseInforRuleForm.orgName,
          pageNo:1,
          pageSize:10
        }).then((res) => {
          this.data = res.data;
        if(this.data.length == 0){
          this.$message({
            dangerouslyUseHTMLString: true,
            message: '<strong style="color:gray;font-size:8px">抱歉没有收到相关结果！你可以：<br/>1.输入准确的关键字，重新搜索<br/>2.点击屏幕右侧"咨询客服"与我们在线沟通。</strong>',
            type: 'error'
          });
          this.companyListShow=false;
          return false;
        }else{
          this.creditCompanyInfo =  this.data.companyInfo;
          this.cities = this.data.cities;
          this.baseInforRuleForm.orgName = this.creditCompanyInfo.companyName;
          this.baseInforRuleForm.regAddrCountry = '86';
          this.baseInforRuleForm.regAddrProvince = this.creditCompanyInfo.province;
          this.baseInforRuleForm.regAddrCity = this.creditCompanyInfo.city;
          this.baseInforRuleForm.regAddrDetail = this.creditCompanyInfo.address;
          if(this.creditCompanyInfo.registCapi == '-'){
            this.baseInforRuleForm.regFund = '';
          }else{
            this.baseInforRuleForm.regFund = this.creditCompanyInfo.registCapi;
          }
          this.baseInforRuleForm.businessScope = this.creditCompanyInfo.scope;
          this.baseInforRuleForm.businessBeginTime = new Date(this.creditCompanyInfo.termStart);
          this.baseInforRuleForm.businessEndTime = new Date(this.creditCompanyInfo.termEnd);
          if(this.creditCompanyInfo.termEnd === ''){
            this.baseInforRuleForm.businessEndTime =new Date('2099-12-31');
            this.baseInforRuleForm.validTime = true;
            this.businessEndTimeShowFlag = false;
          }else{
            this.baseInforRuleForm.businessEndTime = new Date(this.creditCompanyInfo.termEnd);
            this.baseInforRuleForm.validTime = false;
            if (this.creditCompanyInfo.termEnd == '4102329600000') {
              this.baseInforRuleForm.validTime = true;
              this.businessEndTimeShowFlag = false;
            }
          }
          this.baseInforRuleForm.orgHead = this.creditCompanyInfo.operName;
          this.baseInforRuleForm.foundDate =  new Date(this.creditCompanyInfo.startDate);
          this.baseInforRuleForm.orgCode = this.creditCompanyInfo.orgNo;
          if(this.creditCompanyInfo.creditNo =='' || this.creditCompanyInfo.creditNo =='-'){
            this.baseInforRuleForm.licenceCode = this.creditCompanyInfo.regNo;
            this.threeFlag = false;
            this.baseInforRuleForm.isThreeToOne = '0';
          }else{
            this.baseInforRuleForm.threeLicenceCode = this.creditCompanyInfo.creditNo;
            this.threeFlag = true;
            this.baseInforRuleForm.isThreeToOne = '1';
          }
        }
        this.companyListShow=false;
      }).catch((err) => {
          console.log(err)
      })


      },
      selectCompanyExt(){
        this.companySearch = this.selectCompanyName;
        // this.baseInforRuleForm.orgName =companyId.split(",")[1];
        this.$axios.post('/onelink.mdata.main.api/mainInfo/findCreditcompanyInfo', {
          companyName: this.baseInforRuleForm.orgName,
          pageNo:1,
          pageSize:10
        }).then((res) => {
          this.data = res.data;
        if(Object.keys(this.data.companyInfo).length == 0){
          this.$message({
            dangerouslyUseHTMLString: true,
            message: '<strong style="color:gray;font-size:8px">抱歉没有收到相关结果！你可以：<br/>1.输入准确的关键字，重新搜索<br/>2.点击屏幕右侧"咨询客服"与我们在线沟通。</strong>',
            type: 'error'
          });
          this.companyListShow=false;
          return false;
        }else{
          this.creditCompanyInfo =  this.data.companyInfo;
          this.cities = this.data.cities;
          this.baseInforRuleForm.orgName = this.creditCompanyInfo.companyName;
          this.baseInforRuleForm.regAddrCountry = '86';
          this.baseInforRuleForm.regAddrProvince = this.creditCompanyInfo.province;
          this.baseInforRuleForm.regAddrCity = this.creditCompanyInfo.city;
          this.baseInforRuleForm.regAddrDetail = this.creditCompanyInfo.address;
          if(this.creditCompanyInfo.registCapi == '-'){
            this.baseInforRuleForm.regFund = '';
          }else{
            this.baseInforRuleForm.regFund = this.creditCompanyInfo.registCapi;
          }
          this.baseInforRuleForm.businessScope = this.creditCompanyInfo.scope;
          this.baseInforRuleForm.businessBeginTime = new Date(this.creditCompanyInfo.termStart);
          this.baseInforRuleForm.businessEndTime = new Date(this.creditCompanyInfo.termEnd);
          if(this.creditCompanyInfo.termEnd === ''){
            this.baseInforRuleForm.businessEndTime =new Date('2099-12-31');
            this.baseInforRuleForm.validTime = true;
            this.businessEndTimeShowFlag = false;
          }else{
            this.baseInforRuleForm.businessEndTime = new Date(this.creditCompanyInfo.termEnd);
            this.baseInforRuleForm.validTime = false;
            if (this.creditCompanyInfo.termEnd == '4102329600000') {
              this.baseInforRuleForm.validTime = true;
              this.businessEndTimeShowFlag = false;
            }
          }
          this.baseInforRuleForm.orgHead = this.creditCompanyInfo.operName;
          this.baseInforRuleForm.foundDate =  new Date(this.creditCompanyInfo.startDate);
          this.baseInforRuleForm.orgCode = this.creditCompanyInfo.orgNo;
          if(this.creditCompanyInfo.creditNo =='' || this.creditCompanyInfo.creditNo =='-'){
            this.baseInforRuleForm.licenceCode = this.creditCompanyInfo.regNo;
            this.threeFlag = false;
            this.baseInforRuleForm.isThreeToOne = '0';
          }else{
            this.baseInforRuleForm.threeLicenceCode = this.creditCompanyInfo.creditNo;
            this.threeFlag = true;
            this.baseInforRuleForm.isThreeToOne = '1';
          }
        }
        this.companyListShow=false;
      }).catch((err) => {
          console.log(err)
      })


      },
      findCompanyInfo(){
        this.$axios.post('/onelink.mdata.main.api/credit/creditFuzzyQuery', {
          companyName: this.baseInforRuleForm.orgName,
          pageNo:1,
          pageSize:10
        }).then((res) => {
          if(res.data.length>0){
          this.companyListShow=true;
        }else{
          this.$alert('<i class="el-icon-error" style="font-size: 32px;color: #F56C6C;position: absolute"></i><p style="padding-left: 48px">抱歉，没有找到相关结果！您可以:</p><p style="padding-left: 48px">1.输入准确的关键词，重新搜索</p><p style="padding-left: 48px">2.点击屏幕右侧"咨询客服"与我们在线沟通。</p>', '', {
            dangerouslyUseHTMLString: true
          });
        }
        this.data = res.data;
        this.companyData = [];
//          if(this.data.length == 0){
//            this.$message({
//              dangerouslyUseHTMLString: true,
//              message: '<strong style="color:gray;font-size:8px">征信系统无法查询到您输入的企业信息<br/>请检查企业名称是否输入有误。<br/><p></p><br/>如有疑问请联系客服400-108-6116</strong>',
//              type: 'success'
//            });
//            return false;
//          }
        this.companyData = this.data;
        this.ruleForm.companyName = this.searchVagueCompany;
        this.findCreditFlag = true;
      }).catch((err) => {
          console.log(err)
      })
      },
      changeValidTime(val){
        this.baseInforRuleForm.validTime = val;
        if(val){
          this.businessEndTimeShowFlag = false;
          this.baseInforRuleForm.businessEndTime =new Date('2099-12-31');
        }else{
          this.baseInforRuleForm.businessEndTime =null;
          this.businessEndTimeShowFlag = true;
        }
        this.$refs['perfectionForm'].validate((valid) => {});
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      selectCountry(countryCode){
        if(countryCode !='86'){
          this.addressFlag = false;
        }else{
          this.addressFlag = true;
        }
        this.baseInforRuleForm.regAddrCountry = countryCode;
        this.baseInforRuleForm.regAddrProvince = '';
        this.baseInforRuleForm.regAddrCity = '';
        this.$axios.post('/onelink.mdata.main.api/region/getProvinces', {
          countryCode:countryCode
        }).then((res) => {
          this.data = res.data;
        this.provinces = this.data;
      }).catch((err) => {
          console.log(err)
      })
      },
      selectProvince(proviceCode){
        this.baseInforRuleForm.regAddrProvince = proviceCode;
        this.baseInforRuleForm.regAddrCity = '';
        this.$axios.post('/onelink.mdata.main.api/region/getCities', {
          provinceCode:proviceCode
        }).then((res) => {
          this.data = res.data;
        this.cities = this.data;
      }).catch((err) => {
          console.log(err)
      })
      },
      selectCity(cityCode){
        this.baseInforRuleForm.regAddrCity = cityCode;
      },
      selectThreeToOne(three){
        if(three == '0'){
          this.threeFlag = false;
          // this.baseInforRuleForm.licenceCodeFileUrl = '';
          // this.baseInforRuleForm.licenceCodeFileName = '';
          // this.baseInforRuleForm.organizationCodeFileUrl = '';
          // this.baseInforRuleForm.organizationCodeFileName = '';
          // this.baseInforRuleForm.taxCodeFileUrl = '';
          // this.baseInforRuleForm.taxCodeFileName = '';
        }
        if(three == '1'){
          this.threeFlag = true;
          // this.baseInforRuleForm.threeLicenceCodeFileName = '';
          // this.baseInforRuleForm.threeLicenceCodeFileUrl = '';
        }
        this.regeistFileDisableFlag = false;
      },
      checkSupplier(check){
        if(!check){
          this.baseInforRuleForm.orgIdentityCheckP = true;
          this.baseInforRuleForm.orgIdentity = '20';
        }else{
          this.baseInforRuleForm.orgIdentityCheckP = false;
          this.baseInforRuleForm.orgIdentity = '10';
        }
      },
      checkPurchaser(check){
        if(!check){
          this.baseInforRuleForm.orgIdentityCheckS = true;
          this.baseInforRuleForm.orgIdentity = '10';
        }else{
          this.baseInforRuleForm.orgIdentityCheckS = false;
          this.baseInforRuleForm.orgIdentity = '20';
        }
      },
      openIndutry(){
        this.filterIndustryKey = '';
        this.openFullScreen(2000);
        this.loading = true;
        this.industryShowFlag = true;
        this.$axios.post('/onelink.mdata.main.api/uCenter/loadIndustries', {
        }).then((res) => {
          this.data = res.data;
        this.industryTree = this.data.rows;
        this.industryTreeStorage=JSON.parse(JSON.stringify(this.data.rows));
        this.industryTreeExt = this.data.rows;
        this.loading = false;
      }).catch((err) => {
          console.log(err)
      })
      },
      filterIndustry(value, data) {
        if (!value) return true;
        if(typeof(data.parent) == "undefined" && data.children !=""){
          data.children.forEach(element =>{
            element.parent = data;
        })
        }
        if(data.industryName.indexOf(value) == -1){
          let industryCheckFlag = false;
          if(typeof(data.parent) != "undefined" ){
            let childrenIndustryNames = '';
            for (let i = 0; i < data.parent.children.length; i++) {
              const element = data.parent.children[i];
              childrenIndustryNames = childrenIndustryNames +element.industryName;
            }
            if(childrenIndustryNames.indexOf(value) == -1 && data.parent.industryName.indexOf(value) != -1){
              industryCheckFlag = true;
            }else{
              industryCheckFlag = false;
            }
          }
          return industryCheckFlag;
        }else{
          let num = data.industryName.indexOf(value);
          data.industryName=data.industryName.slice(0,num)+'<span style="color:red">'+value+'</span>'+data.industryName.slice(num+value.length)
          this.filterIndustryNumber++;
          return true;
        }
      },
      filterSerivce(value, data) {
        if (!value) return true;
        if(typeof(data.parent) == "undefined" && data.children !=""){
          data.children.forEach(element =>{
            element.parent = data;
        })
        }
        // this.serviceTree.push(data);
        if(data.serviceName.indexOf(value) == -1){
          let serviceCheckFlag = false;
          if(typeof(data.parent) != "undefined" && data.children!=""){
            let childrenServiceNames = '';
            for (let i = 0; i < data.parent.children.length; i++) {
              const element = data.parent.children[i];
              childrenServiceNames = childrenServiceNames +element.serviceName;
            }
            if(childrenServiceNames.indexOf(value) == -1 && data.parent.serviceName.indexOf(value) != -1){
              serviceCheckFlag = true;
            }else{
              serviceCheckFlag = false;
            }
          }
          return serviceCheckFlag;
        }else{
          let num = data.serviceName.indexOf(value);
          data.serviceName=data.serviceName.slice(0,num)+'<span style="color:red">'+value+'</span>'+data.serviceName.slice(num+value.length)
          this.filterServiceNumber++;
          return true;
        }
      },
      openService(){
        this.filterServiceKey = '';
        this.openFullScreen(2000);
        this.loading = true;
        this.serviceShowFlag = true;
        this.$axios.post('/onelink.mdata.main.api/uCenter/loadServices', {
        }).then((res) => {
          this.data = res.data;
        this.serviceTree = this.data.rows;
        this.serviceTreeStorage = JSON.parse(JSON.stringify(this.data.rows));
        this.loading = false;
      }).catch((err) => {
          console.log(err)
      })
      },
      changeIndustry(val){
        this.multipleIndustrySelection = val;
      },
      changeService(val){
        this.multipleServiceSelection = val;
      },
      handleCheckIndustryChange(data, checked, indeterminate) {
        let selectIndustry = {};
        selectIndustry.id = data.id;
        selectIndustry.industryName = data.industryName;
        // this.baseInforRuleForm.industriesDtos.push(selectIndustry);
        this.baseInforRuleForm.industriesExtDtos.push(selectIndustry);
      },
      handleCheckServiceChange(data, checked, indeterminate) {
        let selectService = {};
        selectService.id = data.id;
        selectService.serviceName = data.serviceName;
        this.baseInforRuleForm.serviceExtDtos.push(selectService);
        // this.baseInforRuleForm.serviceDtos.push(selectService);
      },
      prewIndustry(){
        this.industryDatas = [];
        this.industryShowFlag = false;
        this.baseInforRuleForm.industriesDtos = this.$refs.tree2.getCheckedNodes();
        this.baseInforRuleForm.industryShowContent = "";
        let industryNumber = 0;
        this.baseInforRuleForm.industriesDtos.forEach(element =>{
          element.children = [];
        let filterIndexStart=element.industryName.indexOf('<span')
        let filterIndexEnd=element.industryName.indexOf('</span>')
        let selectIndustryName = '';
        if(filterIndexStart !=-1 && filterIndexEnd!=-1){
          selectIndustryName=element.industryName.slice(0,filterIndexStart)+element.industryName.slice(filterIndexStart+24,filterIndexEnd)+element.industryName.slice(filterIndexEnd+7)
        }else{
          selectIndustryName=element.industryName;
        }
        this.industryData = {industryName:"",industryIndex:0};
        this.industryData.industryIndex = industryNumber;
        this.industryData.industryName = selectIndustryName;
        this.industryDatas.push(this.industryData);
        industryNumber++;
        this.baseInforRuleForm.industryShowContent=this.baseInforRuleForm.industryShowContent + '[' + selectIndustryName + ']';
      })
        this.baseInforRuleForm.industryDatas = this.industryDatas;
        this.$refs['perfectionForm'].validate((valid) => {});
      },
      removeIndustry(industryName,id){
        this.industryDatas.forEach(element =>{
          if(element.industryIndex == id){
          this.industryDatas.splice(id,1);
        }
      });
        let industryNumber = 0;
        this.baseInforRuleForm.industryShowContent = "";
        let industryExtDatas = this.industryDatas;
        this.industryDatas = [];
        industryExtDatas.forEach(element =>{
          let selectIndustryName = element.industryName;
        this.industryData = {industryName:"",industryIndex:0};
        this.industryData.industryIndex = industryNumber;
        this.industryData.industryName = selectIndustryName;
        this.industryDatas.push(this.industryData);
        industryNumber++;
        this.baseInforRuleForm.industryShowContent=this.baseInforRuleForm.industryShowContent + '[' + selectIndustryName + ']';
      });
        this.baseInforRuleForm.serviceDatas = this.serviceDatas;
        this.$refs['perfectionForm'].validate((valid) => {});
      },
      prewService(){
        this.serviceDatas = [];
        this.serviceShowFlag = false;
        this.baseInforRuleForm.serviceDtos = this.$refs.tree3.getCheckedNodes();
        this.baseInforRuleForm.serviceShowContent = "";
        let serviceNumber = 0;
        this.baseInforRuleForm.serviceDtos.forEach(element =>{
          element.children = [];
        let filterIndexStart=element.serviceName.indexOf('<span')
        let filterIndexEnd=element.serviceName.indexOf('</span>')
        let selectServiceame = '';
        if(filterIndexStart != -1 && filterIndexEnd != -1){
          selectServiceame=element.serviceName.slice(0,filterIndexStart)+element.serviceName.slice(filterIndexStart+24,filterIndexEnd)+element.serviceName.slice(filterIndexEnd+7)
        }else{
          selectServiceame=element.serviceName;
        }

        this.serviceData = {serviceName:"",serviceIndex:0};
        this.serviceData.serviceIndex = serviceNumber;
        this.serviceData.serviceName = selectServiceame;
        this.serviceDatas.push(this.serviceData);
        serviceNumber++;
        this.baseInforRuleForm.serviceShowContent=this.baseInforRuleForm.serviceShowContent + '[' + selectServiceame + ']';
      })
        this.baseInforRuleForm.serviceDatas = this.serviceDatas;
        this.$refs['perfectionForm'].validate((valid) => {});
      },

      removeService(serviceName,id){
        this.serviceDatas.forEach(element =>{
          if(element.serviceIndex == id){
          this.serviceDatas.splice(id,1);
        }
      });
        this.baseInforRuleForm.serviceShowContent = "";
        let serviceNumber = 0;
        let serviceExtDatas = this.serviceDatas;
        this.serviceDatas = [];
        serviceExtDatas.forEach(element =>{
          let selectServiceame = element.serviceName;
        this.serviceData = {serviceName:"",serviceIndex:0};
        this.serviceData.serviceIndex = serviceNumber;
        this.serviceData.serviceName = selectServiceame;
        this.serviceDatas.push(this.serviceData);
        serviceNumber++;
        this.baseInforRuleForm.serviceShowContent=this.baseInforRuleForm.serviceShowContent + '[' + selectServiceame + ']';
      });
        this.baseInforRuleForm.serviceDatas = this.serviceDatas;
        this.$refs['perfectionForm'].validate((valid) => {});
      },
      closeIndustry(){
        this.industryShowFlag = false;
      },
      closeService(){
        this.serviceShowFlag = false;
      },
      tirggerThreeLienceCodeFile(event){
        if(this.baseInforRuleForm.threeLicenceCodeFileUrl!=''){
          this.$message({
            message: "您已上传附件，若您需要更新附件，请先删除原附件",
            type: 'error'
          });
          return false;
        }
        let file = event.target.files[0];
        let fileName = String(file.name);
        let fileSize = file.size;
        var AllImgExt=".jpg|.jpeg|.png|.pdf|.doc|.docx|";
        var extName = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
        if(AllImgExt.indexOf(extName+"|")==-1){
          this.$message({
            message: "仅支持JPG、JPEG、PNG、PDF、DOC、DOCX格式",
            type: 'error'
          });
          return false;
        }
        if(fileSize/1024/1024 >10){
          this.$message({
            message: "上传文件不得超过10M",
            type: 'error'
          });
          return false;
        }
        this.baseInforRuleForm.upfile = event.target.files; // (利用console.log输出看结构就知道如何处理档案资料)
        let formData = new FormData();
        formData.append('upfile', file);
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        this.$axios.post('/onelink.mdata.main.api/upload/uploadSync', formData,config).then((res) => {
          this.data = res.data;
        this.baseInforRuleForm.threeLicenceCodeFileName = this.data.fileName;
        if(this.baseInforRuleForm.threeLicenceCodeFileName){
          this.deleteThreeLicTxt="删除";
        }else{
          this.deleteThreeLicTxt="";
        }
        this.baseInforRuleForm.threeLicenceCodeFileUrl = this.data.fileUrl;
        this.baseInforRuleForm.threeLicenceCodeFileKey = this.data.fileKey;
        this.baseInforRuleForm.threeLicenceCode = this.baseInforRuleForm.threeLicenceCode + " ";
        this.showThreeLienceFlag = true;
        this.$refs['perfectionForm'].validate((valid) => {});

        // this.baseInforRuleForm.threeLicenceCode = currentThreeLicenceCode;
      }).catch((err) => {
          console.log(err)
      })
      },
      viewAttachment(url){
        window.location.href=url;
      },
      tirggerLienceCodeFile(event){
        if(this.baseInforRuleForm.licenceCodeFileUrl!=''){
          this.$message({
            message: "您已上传附件，若您需要更新附件，请先删除原附件",
            type: 'error'
          });
          return false;
        }
        let file = event.target.files[0];
        let fileName = String(file.name);
        let fileSize = file.size;
        var AllImgExt=".jpg|.jpeg|.png|.pdf|.doc|.docx|";
        var extName = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
        if(AllImgExt.indexOf(extName+"|")==-1){
          this.$message({
            message: "仅支持JPG、JPEG、PNG、PDF、DOC、DOCX格式",
            type: 'error'
          });
          return false;
        }
        if(fileSize/1024/1024 >10){
          this.$message({
            message: "上传文件不得超过10M",
            type: 'error'
          });
          return false;
        }
        this.baseInforRuleForm.upfile = event.target.files; // (利用console.log输出看结构就知道如何处理档案资料)
        let formData = new FormData();
        formData.append('upfile', file);
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        this.$axios.post('/onelink.mdata.main.api/upload/uploadSync', formData,config).then((res) => {
          this.data = res.data;
        this.baseInforRuleForm.licenceCodeFileName = this.data.fileName;
        if(this.baseInforRuleForm.licenceCodeFileName){
          this.deleteLicTxt="删除"
        }else{
          this.deleteLicTxt=""
        }
        this.baseInforRuleForm.licenceCodeFileUrl = this.data.fileUrl;
        this.baseInforRuleForm.licenceCodeFileKey = this.data.fileKey;
        this.showLienceFlag = true;
        this.$refs['perfectionForm'].validate((valid) => {});
      }).catch((err) => {
          console.log(err)
      })
      },
      tirggerOrganizationCodeFile(event){
        if(this.baseInforRuleForm.organizationCodeFileUrl!=''){
          this.$message({
            message: "您已上传附件，若您需要更新附件，请先删除原附件",
            type: 'error'
          });
          return false;
        }
        let file = event.target.files[0];
        let fileName = String(file.name);
        let fileSize = file.size;
        var AllImgExt=".jpg|.jpeg|.png|.pdf|.doc|.docx|";
        var extName = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
        if(AllImgExt.indexOf(extName+"|")==-1){
          this.$message({
            message: "仅支持JPG、JPEG、PNG、PDF、DOC、DOCX格式",
            type: 'error'
          });
          return false;
        }
        if(fileSize/1024/1024 >10){
          this.$message({
            message: "上传文件不得超过10M",
            type: 'error'
          });
          return false;
        }
        this.baseInforRuleForm.upfile = event.target.files; // (利用console.log输出看结构就知道如何处理档案资料)
        let formData = new FormData();
        formData.append('upfile', file);
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        this.$axios.post('/onelink.mdata.main.api/upload/uploadSync', formData,config).then((res) => {
          this.data = res.data;
        this.baseInforRuleForm.organizationCodeFileName = this.data.fileName;
        this.baseInforRuleForm.organizationCodeFileUrl = this.data.fileUrl;
        if(this.baseInforRuleForm.organizationCodeFileName){
          this.deleteOrgTxt='删除';
        }else{
          this.deleteOrgTxt='';
        }

        this.baseInforRuleForm.organizationCodeFileKey = this.data.fileKey;
        this.showOrganizationFlag = true;
        this.$refs['perfectionForm'].validate((valid) => {});
      }).catch((err) => {
          console.log(err)
      })
      },
      tirggerTaxCodeFile(event){
        if(this.baseInforRuleForm.taxCodeFileUrl!=''){
          this.$message({
            message: "您已上传附件，若您需要更新附件，请先删除原附件",
            type: 'error'
          });
          return false;
        }
        let file = event.target.files[0];
        let fileName = String(file.name);
        let fileSize = file.size;
        var AllImgExt=".jpg|.jpeg|.png|.pdf|.doc|.docx|";
        var extName = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
        if(AllImgExt.indexOf(extName+"|")==-1){
          this.$message({
            message: "仅支持JPG、JPEG、PNG、PDF、DOC、DOCX格式",
            type: 'error'
          });
          return false;
        }
        if(fileSize/1024/1024 >10){
          this.$message({
            message: "上传文件不得超过10M",
            type: 'error'
          });
          return false;
        }
        this.baseInforRuleForm.upfile = event.target.files; // (利用console.log输出看结构就知道如何处理档案资料)
        let formData = new FormData();
        formData.append('upfile', file);
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        this.$axios.post('/onelink.mdata.main.api/upload/uploadSync', formData,config).then((res) => {
          this.data = res.data;
        this.baseInforRuleForm.taxCodeFileName = this.data.fileName;
        if(this.baseInforRuleForm.taxCodeFileName){
          this.deleteTaxTxt="删除"
        }else{
          this.deleteTaxTxt=""
        }
        this.baseInforRuleForm.taxCodeFileUrl = this.data.fileUrl;
        this.baseInforRuleForm.taxCodeFileKey = this.data.fileKey;
        this.showTaxFlag = true;
        this.$refs['perfectionForm'].validate((valid) => {});
      }).catch((err) => {
          console.log(err)
      })
      },
      tirggerBussinessChangeFile(event){
        if(this.baseInforRuleForm.bussinessChangeFileUrl!=''){
          this.$message({
            message: "您已上传附件，若您需要更新附件，请先删除原附件",
            type: 'error'
          });
          return false;
        }
        let file = event.target.files[0];
        let fileName = String(file.name);
        let fileSize = file.size;
        var AllImgExt=".jpg|.jpeg|.png|.pdf|.doc|.docx|";
        var extName = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
        if(AllImgExt.indexOf(extName+"|")==-1){
          this.$message({
            message: "仅支持JPG、JPEG、PNG、PDF、DOC、DOCX格式",
            type: 'error'
          });
          return false;
        }
        if(fileSize/1024/1024 >10){
          this.$message({
            message: "上传文件不得超过10M",
            type: 'error'
          });
          return false;
        }
        this.baseInforRuleForm.upfile = event.target.files; // (利用console.log输出看结构就知道如何处理档案资料)
        let formData = new FormData();
        formData.append('upfile', file);
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        this.$axios.post('/onelink.mdata.main.api/upload/uploadSync', formData,config).then((res) => {
          this.data = res.data;
        this.baseInforRuleForm.bussinessChangeFileUrl = this.data.fileUrl;
        this.baseInforRuleForm.bussinessChangeFileName = this.data.fileName;
        this.baseInforRuleForm.bussinessChangeFileKey = this.data.fileKey;
        this.showBussinessFlag = true;
        this.$refs['perfectionForm'].validate((valid) => {});
      }).catch((err) => {
          console.log(err)
      })
      },
      viewAttachment(url){
        window.location.href=url;
      },
      deleteThreeLienceCodeFile(){
        this.baseInforRuleForm.threeLicenceCodeFileName = '';
        this.showThreeLienceFlag=false;
        this.baseInforRuleForm.threeLicenceCodeFileUrl = '';
        this.baseInforRuleForm.threeLicenceCodeFileKey = '';
        // this.$refs.threeLicenceCodeFile.value= '';
        this.baseInforRuleForm.threeLicenceCode = this.baseInforRuleForm.threeLicenceCode.trim();
        this.$refs['perfectionForm'].validate((valid) => {});
      },
      deleteLienceCodeFile(){
        this.baseInforRuleForm.licenceCodeFileName = '';
        this.deleteLicTxt="";
        this.baseInforRuleForm.licenceCodeFileUrl = '';
        this.baseInforRuleForm.licenceCodeFileKey = '';
        this.showLienceFlag = false;
        this.$refs.licenceCodeFile.value= '';
        this.$refs['perfectionForm'].validate((valid) => {});
      },
      deleteOrganizationCodeFile(){
        this.baseInforRuleForm.organizationCodeFileName = '';
        this.deleteOrgTxt='';
        this.baseInforRuleForm.organizationCodeFileUrl = '';
        this.baseInforRuleForm.organizationCodeFileKey = '';
        this.showOrganizationFlag = false;
        this.$refs.organizationCodeFile.value= '';
        this.$refs['perfectionForm'].validate((valid) => {});
      },
      deleteTaxCodeFile(){
        this.baseInforRuleForm.taxCodeFileName = '';
        this.deleteTaxTxt="";
        this.baseInforRuleForm.taxCodeFileUrl = '';
        this.baseInforRuleForm.taxCodeFileKey = '';
        this.showTaxFlag = false;
        this.$refs.taxCodeFile.value= '';
        this.$refs['perfectionForm'].validate((valid) => {});
      },
      deleteBussinessChangeFile(){
        this.baseInforRuleForm.bussinessChangeFileName = '';
        this.baseInforRuleForm.bussinessChangeFileUrl = '';
        this.baseInforRuleForm.bussinessChangeFileKey = '';
        this.showBussinessFlag = false;
        this.$refs.bussinessChangeFile.value= '';
        this.$refs['perfectionForm'].validate((valid) => {});
      },
      goToHref(val){
        this.$router.push({path: val})
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/appointment/index.vue